export enum MeetingStatus {
    END = "END",
    INPROGRESS = "INPROGRESS",
    PENDING = "PENDING",
    CANCEL = "CANCEL",
    DELETE = "DELETE"
}
export enum StatusBadgeVariant {

    PENDING = "warning",
    INPROGRESS = "success",
    END = "secondary",
    CANCEL = "danger"
}
export enum StatusText {

    PENDING = "meetingStatusPending",
    INPROGRESS = "meetingStatusInProgress",
    END = "meetingStatusEnded",
    CANCEL = "meetingStatusCancelled",
}
export enum ReportSelectOptionsEnum {
    MEETING_COUNT = "totalMeetings",
    MEETING_DURATION = "totalActualDuration",
    STORAGE_CAPACITY = "maxStorageSize",
    STORAGE_USED = "totalRecordingSize",
    SUMMARY_DURATION = "totalMeetings"
}